import { ProductSeriesEntity } from '../../types';

export enum ProductsSeriesActions {
  FetchSeriesBegin = 'PRODUCTS/SERIES/FETCH/BEGIN',
  FetchSeriesSuccess = 'PRODUCTS/SERIES/FETCH/SUCCESS',
  FetchSeriesError = 'PRODUCTS/SERIES/FETCH/ERROR',
}

export interface ProductsSeriesStore {
  isLoading: boolean;
  isLoaded: boolean;
  error: any;
  productSeries: ProductSeriesEntity;
}
